/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBrushIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-brush"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.95 21.35Q4.67 21.35 3.46 20.73Q2.25 20.1 1.5 19.05Q2.17 19.13 2.94 18.6Q3.7 18.07 3.7 17.05Q3.7 15.7 4.67 14.75Q5.65 13.8 7 13.8Q8.35 13.8 9.3 14.75Q10.25 15.7 10.25 17.05Q10.25 18.82 8.99 20.09Q7.72 21.35 5.95 21.35ZM12 15.05L9 12.05L18.25 2.75Q18.52 2.48 18.96 2.46Q19.4 2.45 19.7 2.75L21.3 4.35Q21.6 4.65 21.6 5.05Q21.6 5.45 21.3 5.75Z" fill={color} />
    </svg>
  );
}
